module.exports = __webpack_public_path__ + "img/banner-one11.52075295.png";